import { Observable, PropertyChangedEventArgs } from "../../events";
export class CameraState {
    constructor(position, target, fov) {
        this._position = position;
        this._target = target;
        this._fov = fov;
    }
    get propertyChangedObservable() {
        if (!this._propertyChangedObservable)
            this._propertyChangedObservable = new Observable();
        return this._propertyChangedObservable;
    }
    get position() {
        return this._position;
    }
    set position(value) {
        if (this._position !== value) {
            const old = this._position;
            this._position = value;
            if (this._propertyChangedObservable?.hasObservers()) {
                const e = new PropertyChangedEventArgs(this, old, this._position, CameraState.POSITION_PROPERTY_NAME);
                this._propertyChangedObservable.notifyObservers(e, -1, this, this);
            }
        }
    }
    get target() {
        return this._target;
    }
    set target(value) {
        if (this._target !== value) {
            const old = this._target;
            this._target = value;
            if (this._propertyChangedObservable?.hasObservers()) {
                const e = new PropertyChangedEventArgs(this, old, this._target, CameraState.TARGET_PROPERTY_NAME);
                this._propertyChangedObservable.notifyObservers(e, -1, this, this);
            }
        }
    }
    get fov() {
        return this._fov;
    }
    set fov(value) {
        if (this._fov !== value) {
            const old = this._fov;
            this._fov = value;
            if (this._propertyChangedObservable?.hasObservers()) {
                const e = new PropertyChangedEventArgs(this, old, this._fov, CameraState.TARGET_PROPERTY_NAME);
                this._propertyChangedObservable.notifyObservers(e, -1, this, this);
            }
        }
    }
    get tanfov2() {
        if (!this._tanfov2) {
            this._tanfov2 = Math.tan((this._fov * Math.PI) / 360);
        }
        return this._tanfov2;
    }
}
CameraState.POSITION_PROPERTY_NAME = "position";
CameraState.TARGET_PROPERTY_NAME = "target";
CameraState.FOV_PROPERTY_NAME = "fov";
//# sourceMappingURL=tiles.navigation.state.camera.js.map